import lozad from "lozad";
import "./icons.js";
import "./../scss/app.scss";

// --- Lazy loading ---
const lozadObserver = lozad(".lozad", { threshold: 0.025 });
lozadObserver.observe();

// --- Main Menu ---
const mainMenu = document.getElementById("main-menu");

function updateMobile() {
	const mobile = window.innerWidth <= 991;
	mainMenu.dataset.ismobile = mobile ? "true" : "false";
	mainMenu.querySelectorAll(".nav-item[data-id]").forEach((item) => {
		item.classList.toggle("hover-item", !mobile);
	});
}

// Desktop sticky: CSS handles position:sticky, JS only toggles visual state
const header = document.querySelector("header");
if (header) {
	window.addEventListener("scroll", () => {
		header.classList.toggle("is-sticky", window.pageYOffset > 0);
	}, { passive: true });
}

if (mainMenu) {
	updateMobile();
	window.addEventListener("resize", updateMobile);
}

// --- Burger toggle ---
document.addEventListener("DOMContentLoaded", function () {
	const burger = document.getElementById("burger");
	const overlay = mainMenu && mainMenu.querySelector(".overlay");
	const navContainer = document.getElementById("nav-container");

	if (burger && overlay) {
		burger.addEventListener("click", function (e) {
			e.preventDefault();
			burger.classList.toggle("active");
			const isOpen = overlay.classList.contains("is-open");
			if (!isOpen && navContainer) {
				overlay.style.top = navContainer.offsetHeight + "px";
			}
			overlay.classList.toggle("is-open", !isOpen);
			if (isOpen) {
				mainMenu.querySelectorAll(".sub-menu.is-open").forEach((el) => {
					el.classList.remove("is-open");
				});
				mainMenu.querySelectorAll(".dropdown-toggle-icon.dropdown-active").forEach((el) => {
					el.classList.remove("dropdown-active");
				});
			}
		});
	}
});

// --- Lazy image loading ---
document.addEventListener("DOMContentLoaded", function () {
	if ("IntersectionObserver" in window) {
		const lazyloadImages = document.querySelectorAll(".lazy");
		const imageObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					const image = entry.target;
					image.src = image.dataset.src;
					image.classList.remove("lazy");
					imageObserver.unobserve(image);
				}
			});
		});
		lazyloadImages.forEach((image) => imageObserver.observe(image));
	} else {
		let lazyloadThrottleTimeout;
		const lazyloadImages = document.querySelectorAll(".lazy");

		function lazyload() {
			if (lazyloadThrottleTimeout) clearTimeout(lazyloadThrottleTimeout);
			lazyloadThrottleTimeout = setTimeout(function () {
				const scrollTop = window.pageYOffset;
				lazyloadImages.forEach(function (img) {
					if (img.offsetTop < window.innerHeight + scrollTop) {
						img.src = img.dataset.src;
						img.classList.remove("lazy");
					}
				});
				if (lazyloadImages.length === 0) {
					document.removeEventListener("scroll", lazyload);
					window.removeEventListener("resize", lazyload);
					window.removeEventListener("orientationChange", lazyload);
				}
			}, 20);
		}

		document.addEventListener("scroll", lazyload);
		window.addEventListener("resize", lazyload);
		window.addEventListener("orientationChange", lazyload);
	}
});

// --- Accordion (CSS transition via max-height) ---
document.querySelectorAll(".accordion-wrap").forEach((wrap) => {
	const btn = wrap.querySelector(".title");
	const body = wrap.querySelector(".accordion");
	const toggle = wrap.querySelector(".toggle");
	if (!btn || !body) return;
	btn.addEventListener("click", () => {
		const opening = !wrap.classList.contains("active");
		wrap.classList.toggle("active", opening);
		toggle && toggle.classList.toggle("open", opening);
		body.classList.toggle("is-open", opening);
	});
});

// --- Hover / click sub-menus ---
var last = null,
	x0,
	x1,
	x2,
	x3,
	y0,
	y1,
	y2,
	y3,
	link,
	timeout;

if (mainMenu) {
	if (mainMenu.dataset.ismobile !== "true") {
		mainMenu.addEventListener("mouseleave", function (event) {
			event.preventDefault();
			mainMenu.dataset.hovering = "off";
			clearTimeout(timeout);
			mainMenu
				.querySelectorAll(".hover-item[data-hovering='true']")
				.forEach((item) => {
					item.dataset.hovering = "false";
					closeSubMenu(item);
				});
		});

		const menuItems = document.querySelectorAll(".hover-item");
		let timer;

		menuItems.forEach((item) => {
			if (typeof item.dataset.id === "undefined" || item.dataset.id === "")
				return;

			item.addEventListener("mouseover", function () {
				if (item.dataset.hovering === "true") return;
				item.dataset.hovering = "true";
				timer = setTimeout(function () {
					openSubMenu(item);
				}, 300);
			});

			item.addEventListener("mouseleave", function () {
				if (item.dataset.hovering === "false") return;
				item.dataset.hovering = "false";
				closeSubMenu(item);
				clearTimeout(timer);
			});
		});
	} else {
		document.querySelectorAll(".dropdown-toggle-icon").forEach((icon) => {
			icon.onclick = function (event) {
				event.preventDefault();
				icon.classList.toggle("dropdown-active");
				const el = document.getElementById("sub-menu-" + icon.dataset.id);
				toggleSubMenu(el);
			};
		});
	}
}

function openSubMenu(parent) {
	const id = parent.dataset.id;
	const el = document.getElementById("sub-menu-" + id);
	if (!el) return;

	if (parent.dataset.flyout === "left") el.style.left = "-100%";

	if (el.dataset.full === "true") {
		el.style.width = itemWidth(el);
		el.style.left = itemLeft(el);
	}
	el.classList.add("is-open");
}

function closeSubMenu(parent) {
	const id = parent.dataset.id;
	const el = document.getElementById("sub-menu-" + id);
	if (!el) return;
	el.classList.remove("is-open");
	parent.dataset.hovering = "false";
}

function toggleSubMenu(el) {
	if (!el) return;
	const isOpen = el.classList.contains("is-open");
	if (isOpen) {
		el.classList.remove("is-open");
		el.querySelectorAll(".sub-menu").forEach((child) => {
			child.classList.remove("is-open");
		});
	} else {
		el.classList.add("is-open");
	}
}

function itemWidth(item) {
	const width = document.getElementById("nav-container").offsetWidth;
	if (item.dataset.from === "_blank") {
		return width - item.parentElement.parentElement.offsetLeft + "px";
	}
	return width + "px";
}

function itemLeft(item) {
	if (item.dataset.from === "_blank") return 0;
	return -item.parentElement.parentElement.offsetLeft + "px";
}

// --- Lazy-load slider and form chunks ---
document.addEventListener("DOMContentLoaded", () => {
	if (document.querySelector(".pi-swiper, .pi-provider-swiper, .pi-testimonial-swiper")) {
		import("./slider.js").then(({ init }) => init());
	}
	if (document.getElementById("contact-form")) {
		import("./form.js").then(({ init }) => init());
	}
});

// --- Click-to scroll ---
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".click-to").forEach((click) => {
		const el = document.getElementById(click.dataset.id);
		if (!el) return;
		click.addEventListener("click", function () {
			window.scroll({
				top: el.getBoundingClientRect().top + window.scrollY,
				behavior: "smooth",
			});
		});
	});
});
